module.exports = __webpack_public_path__ + "b47f464521f927ec28541e17c767a4b3.png";